'use client';

import { useState } from 'react';
import { BottomSheet, Container, Hidden } from '@doist/marketist';
import cn from 'clsx';
import { useTranslation } from 'next-i18next';
import { PlanControls } from '../controls/controls';
import { Showcase } from './showcase/showcase';
import css from './plans.module.css';
export function Plans() {
  const {
    t
  } = useTranslation('pricing_v2_3');
  const [isBottomSheetOpen, setIsBottomSheetOpen] = useState(false);
  return <>
            <Container width="lg" data-sentry-element="Container" data-sentry-source-file="plans.tsx">
                <Hidden below="lg" data-sentry-element="Hidden" data-sentry-source-file="plans.tsx">
                    <PlanControls className={cn(css.planControls, 'mbe-24')} data-sentry-element="PlanControls" data-sentry-source-file="plans.tsx">
                        <PlanControls.BillingCycle data-sentry-element="unknown" data-sentry-source-file="plans.tsx" />
                        <PlanControls.Currency data-sentry-element="unknown" data-sentry-source-file="plans.tsx" />
                    </PlanControls>
                </Hidden>
                <Showcase data-sentry-element="Showcase" data-sentry-source-file="plans.tsx" />
            </Container>

            <Hidden above="lg" data-sentry-element="Hidden" data-sentry-source-file="plans.tsx">
                <BottomSheet title={isBottomSheetOpen ? t('billing.optionsHide') : t('billing.optionsShow')} onOpen={() => setIsBottomSheetOpen(true)} onClose={() => setIsBottomSheetOpen(false)} data-sentry-element="BottomSheet" data-sentry-source-file="plans.tsx">
                    <PlanControls data-sentry-element="PlanControls" data-sentry-source-file="plans.tsx">
                        <PlanControls.BillingCycle data-sentry-element="unknown" data-sentry-source-file="plans.tsx" />
                        <PlanControls.Currency data-sentry-element="unknown" data-sentry-source-file="plans.tsx" />
                    </PlanControls>
                </BottomSheet>
            </Hidden>
        </>;
}